import { Directive, inject, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { AppAuthService, AWS_CUSTOM_ATTRIBUTES } from '../services/app-auth.service';
import { AppLogService } from '../services/app-log.service';

@Directive({
  selector: '[ifUserTypes]',
  standalone: false,
})
export class IfUserTypesDirective implements OnInit {
  // the role the user must have
  @Input() public ifUserTypes: string[];

  /**
   * @param {ViewContainerRef} viewContainerRef -- the location where we need to render the templateRef
   * @param {TemplateRef<any>} templateRef -- the templateRef to be potentially rendered
   * @param {AppAppAuthService } appAppAuthService  -- will give us access to the roles a user has
   */
  private _viewContainerRef = inject(ViewContainerRef);
  private _templateRef = inject(TemplateRef<any>);
  private _authService = inject(AppAuthService);

  ngOnInit(): void {
    try {
      const userType: string | null = this._authService.getCustomAttribute(AWS_CUSTOM_ATTRIBUTES.UserType);

      if (this.ifUserTypes.length == 0 || this.ifUserTypes.indexOf(userType) > -1) {
        this._viewContainerRef.createEmbeddedView(this._templateRef);
        return;
      }

      this._viewContainerRef.clear();
    } catch (error) {
      AppLogService.error(error);
      this._viewContainerRef.clear();
    }
  }
}
